import React from 'react';
import styled from 'styled-components';
import {Subhead} from '../../../../components/Typography';

const LocationUnavailable = styled.div`
  border-radius: 8px;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
`;

const UnavailableMessage = ({title, marginTop}) => {
  return (
    <LocationUnavailable marginTop={marginTop}>
      <i className="fal fa-exclamation-circle" style={{marginRight: "3px"}}/>
      <Subhead style={{fontWeight: '400'}}>{title}</Subhead>
    </LocationUnavailable>
  );
};

export default UnavailableMessage;
